export type Color = keyof typeof colors
export type ColorValue = (typeof colors)[Color]
export type ColorDef = {
  [key: string]: string | ColorDef
}

export const colors = {
  // colors
  lightBrown: '#c66e43',
  auburn: '#bc5e30',
  earth: '#b44b27',
  darkBrown: '#8c4325',
  yellow: '#da9a3e',
  green: '#5f6851',
  red: '#b83a2d',
  darkerBrown: '#632a10',
  // defaults
  white: '#ffffff',
  offWhite: '#f3f2f0',
  lightGrey: '#EAF0F5',
  midGrey: '#D5DEE7',
  grey: '#8E9BAD',
  border: '#a79f90',
  darkGrey: '#a19a8c',
  black: '#222222',
  teal: '#3FC0C3',
  navy: '#0D1330',
  slate: '#54595F',
  blue: '#2A4B9B',
  lightBlue: '#009ade',
  ligherBlue: '#4AC4F0',
  darkerGreen: '#26B861',
  lightGreen: '#ECFBF6',
  lightRed: '#F4E2E6',
  lightYellow: '#FFF8ED',
  orange: '#FF9A39',
  lightOrange: '#ffa000',
  purple: '#4A34D4',
  blueNew: '#2362FC',
  facebook: '#3b5998',
  twitter: '#00acee',
  instagram: '#E1306C',
  youtube: '#FF0000',
  linkedin: '#86888a',
  concrete: '#f3f3f3',
}
